import { RecurrenceSettingsState } from '../../../types'

export function updateRecurrencePeriod(
  state: RecurrenceSettingsState,
  recurrencePeriod: uui.domain.ui.forms.RecurrencePeriod['period'],
): RecurrenceSettingsState {
  return {
    ...state,
    value: {
      ...state.value,
      recurrencePeriod: {
        ...state.value.recurrencePeriod,
        period: recurrencePeriod,
      },
    },
  }
}
